import React, { useContext, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import DivRow from '../controls/DivRow';
import DropDownInput from '../controls/DropDownInput';
import Input from '../controls/Input';
import Modal from 'react-modal';
import { tipoDocumentos } from '../../data/mochaData';
import { cedulaMask, cedulaPattern, customStyles, endPoints, tipoId } from '../../utils/constanst';
import http from '../../services/http';
import CotizadorCRProvider, { CotizadorCRDataContext } from '../../context/CotizadorCRDataContext';
import Container from '../Container';
import { dataDefault } from '../../data/cotizadorCrData';

const MicrositioAutoCR = ({ location, history, ...rest }) => {
    const letterPattern = "[a-zA-ZÀ-ÿ\u00f1\u00d1 ]+";

    // const dataDefault = { tipoId: '1', identificacion: '', nombre: '', apellido: '', email: '', celular: '', showModal: false, showAcceptModel: false, sendDisabled: false };

    const [data, setData] = useState(dataDefault);
    const { poliza, setPoliza, polizaChangeHandler } = useContext(CotizadorCRDataContext);

    useEffect(() => {

        setTimeout(() => {
            const preloader = document.querySelector('.site-preloader');

            if (preloader) {
                preloader.addEventListener('transitionend', (event) => {
                    if (event.propertyName === 'opacity') {
                        preloader.parentNode.removeChild(preloader);
                    }
                });
                preloader.classList.add('site-preloader__fade');
            }
        }, 600);

    }, [0]);

    const changeHandler = event => {
        let d = { ...data, [event.target.name]: event.target.value };
        setData(d);

        setPoliza({
            asegurado: {
                tipoId: d.tipoId,
                numId: d.identificacion,
                nombre: d.nombre,
                apellido: d.apellido,
                email: d.email,
                celular: d.celular
            }
        });
    }

    const onAcceptChange = (e) => {
        if (e.target.checked)
            openAcceptModal();
    }

    const closeAcceptModal = () => setData({ ...data, showAcceptModel: false });
    const openAcceptModal = () => setData({ ...data, showAcceptModel: true });



    const sendNotification = () => {
        let result = document.querySelector('form').reportValidity();

        if (!result) return;

        let searchParams = new URLSearchParams(location.search);
        let src = searchParams.get('source');
        data.nombres = data.nombre + ' ' + data.apellido;
        data["source"] = src;


        if (poliza.sendNotificationAuto) {
            setPoliza({ ...poliza, loading: true });
            http(endPoints.notificationAuto).post({ ...data })
                .then(x => {
                    setPoliza({ ...poliza, loading: false });
                }).catch(e => {
                    setPoliza({ ...poliza, loading: false });
                }).finally(() => history.push('/micrositio/cotizadorcr'));
        }
        else
            history.push('/micrositio/cotizadorcr')


    }

    return (

        <Container>

            <div className="layout cotizadorcr" style={{ maxWidth: "580px" }}>
                <div className="header-section">
                    <h2 className="txt-esmeralda txt-light text-center">¡Calcule su seguro ahora!</h2>
                    <h3 className="txt-light text-center">Con su póliza de Automóvil LAFISE Plus<br /> disfrute cada momento sin preocupaciones</h3>
                </div>
                <form action="" className="lfcontainer">
                    <div className="step">
                        <DivRow width='100%' >

                            {data.tipoId == tipoId.cedula &&

                                <DropDownInput label='Documentación' dataProvider={tipoDocumentos}
                                    value={data.identificacion} onChange={changeHandler}
                                    valueSelect={data.tipoId} onChangeSelect={changeHandler}
                                    field='identificacion'
                                    fieldSelect='tipoId'
                                    mask="9-9999-9999"
                                    pattern="\d-\d\d\d\d-\d\d\d\d"
                                    title="Documento invalido"
                                />
                            }

                            {data.tipoId != tipoId.cedula &&

                                <DropDownInput label='Documentación' dataProvider={tipoDocumentos}
                                    value={data.identificacion} onChange={changeHandler}
                                    valueSelect={data.tipoId} onChangeSelect={changeHandler}
                                    field='identificacion'
                                    fieldSelect='tipoId'
                                    title="Documento invalido"
                                />
                            }


                            <Input type="text" label='Nombres' field='nombre' value={data.nombre} onChange={changeHandler} pattern={letterPattern} />
                            <Input type="text" label='Apellidos' field='apellido' value={data.apellido} onChange={changeHandler} pattern={letterPattern} />

                            <Input label='Correo electrónico' field='email' value={data.email} onChange={changeHandler} />
                            <Input label='Celular' pattern='\d\d\d\d-\d\d\d\d' title='Teléfono inválido' type='maskInput' mask='9999-9999' field='celular' placeholder='0000-0000' value={data.celular} onChange={changeHandler} />

                            <div>
                                <input type="checkbox" name="" id="teminosycondiciones" required onChange={onAcceptChange} />
                                <label htmlFor="teminosycondiciones" style={{ textAlign: "justify" }}>
                                    Acepto que he leído y consecuentemente brindo mi consentimiento a SEGUROS LAFISE para el uso de mi información según lo indicado en las Políticas de Privacidad, Términos y Condiciones
                                </label>
                            </div>
                            <br />
                            <label style={{ textAlign: "justify" }}>
                                El presente producto se encuentra registrado ante la SUGESE bajo el nombre de SEGURO DE AUTOMÓVILES LAFISE PLUS y número de Registro G01-01-A14-715 de Seguros
                            </label>

                        </DivRow>
                    </div>

                </form>
                <div className="align-r">
                    <DivRow width='100%'>
                        <button className="control-button-btn btn-next"
                            type="button"
                            onClick={sendNotification}
                            disabled={data.sendDisabled}
                        >Siguiente</button>
                    </DivRow>

                </div>

                <Modal
                    isOpen={data.showAcceptModel}
                    onRequestClose={closeAcceptModal}
                    style={customStyles}
                    shouldCloseOnOverlayClick={false}
                    contentLabel="Example Modal"
                    ariaHideApp={false}
                >
                    <div className="dialog-center-content">
                        <div className="fontsize14">
                            <h3 className="h3 txt-primary txt-center"></h3>
                            <p style={{ textAlign: 'justify' }}>
                                En cumplimiento con la Ley 8204 y la Política Conozca a su Cliente, declaro que este formulario ha sido completado por mí y/o en mi presencia y que la información provista en el mismo es fiel y verdadera. Asi mismo, declaro que los recursos por movilizar a través de Seguro LAFISE (en adelante S.L.) provienen de actividades lícitas. La información de este formulario puede ser utilizada por cualquiera de las empresas del S.L. para los fines respectivos.
                            </p>
                            <br />
                        </div>
                    </div>

                    <div className="dialog-center-content">
                        <button type="button" className="control-button-btn btn-color-primary" onClick={closeAcceptModal}>Cerrar</button>
                    </div>
                </Modal>

                <Modal className="modal" isOpen={poliza.loading} show={poliza.loading} ariaHideApp={false}>
                    <div className="dialog-center-content">
                        <p className="text-center">Cargando...</p>
                    </div>
                </Modal>
            </div>


        </Container>

    );
}





export default MicrositioAutoCR;
